/**
 * Text measuring logics.
 */
export * from './optimized';
export * from './regular';
